import { render } from "./DashboardLayoutComponent.vue?vue&type=template&id=69f876bc"
import script from "./DashboardLayoutComponent.vue?vue&type=script&lang=js"
export * from "./DashboardLayoutComponent.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__